import { useEffect } from "react";

export const usePrecisionGameTimer = (
  firstClickTime: number | null,
  setCurrentTime: (time: number) => void
) => {
  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    if (firstClickTime !== null) {
      interval = setInterval(() => {
        setCurrentTime(Date.now() - firstClickTime);
      }, 10);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [firstClickTime, setCurrentTime]);
};
